import Http from '@/libs/http.js';

/**
 * 获取项目列表
 * @returns {Promise}
 */
export const getProjectByUserId = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getProjectByUserId',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 获取项目信息
 * @returns {Promise}
 */
export const getProjectInfo = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getProjectInfo',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 获取审批进度信息
 * @returns {Promise}
 */
export const getBusinessInfoByProjectId = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http(window.host2)
        instance.get('/getBusinessInfoByProjectId',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 获取审批计划信息
 * @returns {Promise}
 */
export const getPlanMessage = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getPlanMessage',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 获取事项定制信息
 * @returns {Promise}
 */
export const getItemCustom = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getItemCustom',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 获取事项定制信息
 * @returns {Promise}
 */
export const analyzeProjectIncomplete = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/analyzeProjectIncomplete',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 获取未完善项目列表
 * @returns {Promise}
 */
export const getDetailProjectIncomplete = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getDetailProjectIncomplete',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};